import Link from 'next/link'
import PostPreview from './post-preview'
import SectionSeparator from './section-separator'

export default function MoreStories({ posts, showHeading }) {

    return (
        <section>
            {
                showHeading ?
                    <>
                        <SectionSeparator />

                        <div className={"flex flex-row justify-content-between mt-24 mb-12"}>
                            <p className={"text-3xl font-medium my-auto"}>Latest articles</p>

                            <Link href={"/insights"}>
                                <button className="p-3 border my-0 ml-auto text-primary font-bold rounded hover:bg-primary hover:text-white transition-all">All Articles</button>
                            </Link>
                        </div>
                    </>
                    :
                    <></>
            }

            <div className={`grid sm:grid-cols-1 lg:grid-cols-3 gap-6 mb-32`}>
                {posts.map((post) => (
                    <PostPreview
                        key={post.slug}
                        title={post.title}
                        coverImage={post.coverImage}
                        date={post.date}
                        author={post.author}
                        slug={post.slug}
                        excerpt={post.excerpt}
                    />
                ))}
            </div>
        </section>
    )
}